import { createSlice } from '@reduxjs/toolkit';

let initialState = {
  bottom: false,
  type: '',
};

const BottomSheetSlice = createSlice({
  name: 'BottomSheet',
  initialState,
  reducers: {
    SetBottomSheetState(state, action) {
      // 바텀시트 상태 설정 { bottom: boolean, type: string }
      state.bottom = action.payload.bottom ?? state.bottom;
      state.type = action.payload.type ?? state.type;
      state.data = action.payload.data;
    },
    OpenBottomSheet(state, action) {
      // 바텀시트 열기
      state.bottom = true;
      if (action.payload?.type) {
        state.type = action.payload.type;
      }
    },
    CloseBottomSheet(state) {
      // 바텀시트 닫기
      state.bottom = false;
      state.type = '';
    },
  },
});

export default BottomSheetSlice.reducer;
export const BottomSheetActions = BottomSheetSlice.actions;
